import { AnyHandler, SimpleHandler } from '../types/@types/sl-v-types';
export class FiniteStateMachine {
  private stateValues: Array<string> = [];
  private _machine: any;
  public states: Array<string> = [];
  constructor(machine: any, states: Array<string>) {
    this._machine = machine;

    states.every((state) => {
      const keyVal = state.split(':');
      if (keyVal.length === 1) {
        this.states.push(keyVal[0]);
        this.stateValues.push(keyVal[0]);
        return true;
      }
      this.states.push(keyVal[0]);
      this.stateValues.push(keyVal[1]);
      return true;
    })
  }

  onSetState: AnyHandler = () => { };
  onStateless: AnyHandler = () => { };
  onStateChanged: AnyHandler = () => { };
  RegisterHandlers(set?: AnyHandler, stateless?: AnyHandler, changed?: AnyHandler) {
    if (!!set) this.onSetState = set;
    if (!!stateless) this.onStateless = stateless;
    if (!!changed) this.onStateChanged = changed;
  }
  GetCurrentState(): string {
    for (const state of this.states) {
      if (this._machine[state] === true) return state;
    }
    return '';
  }
  GetCurrentValue(): string {
    let i = -1;
    for (const state of this.states) {
      i += 1;
      if (this._machine[state] === true) return this.stateValues[i];
    }
  }
  GetStateValue(state: string) {
    const stateIndex = this.states.indexOf(state);
    if (stateIndex > -1) return this.stateValues[stateIndex];
    return '';
  }
  GetValueState(value: string) {
    const valueIndex = this.stateValues.indexOf(value);
    if (valueIndex > -1) return this.states[valueIndex];
  }
  SetValue(value: string, isOn: boolean) {
    this.SetState(this.GetValueState(value), isOn);
  }
  SetState(state: string, isOn: boolean) {
    const wasSet = this._machine[state];
    // if (this._machine[state] === isOn) return;
    let matched = false;
    this.states.every((s) => {
      if (s !== state) {
        if (isOn === true) {
          this._machine[s] = false;
        }
      } else {
        this._machine[s] = isOn;
      }
      if (this._machine[s] === true) matched = true;
      return true;
    });
    if (!!this._machine[state]) {
      this.StateSet(state);
    } else {
      if (matched === false) {
        this.Stateless();
      }
    }
    this.StatesChanged();

  }
  StateSet(state: string) {

    this.onSetState({ src: this, state: state, isOn: this._machine[state], value: this.GetStateValue(state) });
  }
  Stateless() {
    this.onStateless({ src: this });
  }
  StatesChanged() {
    this.onStateChanged({ src: this });
  }

}
